import { render } from "./edituser.vue?vue&type=template&id=60b59e26&scoped=true"
import script from "./edituser.vue?vue&type=script&lang=js"
export * from "./edituser.vue?vue&type=script&lang=js"

import "./edituser.vue?vue&type=style&index=0&id=60b59e26&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b59e26"]])

export default __exports__